import { render, staticRenderFns } from "./WikiStructure.vue?vue&type=template&id=b49f1304"
import script from "./WikiStructure.vue?vue&type=script&lang=js"
export * from "./WikiStructure.vue?vue&type=script&lang=js"
import style0 from "./WikiStructure.vue?vue&type=style&index=0&id=b49f1304&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports